const sortInAfterItems = (targetList, afterItems) => {
  const result = [...targetList];
  const remainingItems = [];
  afterItems.forEach((afterItem) => {
    const index = result.findIndex((targetItem) => {
      var _a;
      return targetItem.description === ((_a = afterItem.position) == null ? void 0 : _a.after);
    });
    if (index !== -1) {
      result.splice(index + 1, 0, afterItem);
    } else {
      remainingItems.push(afterItem);
    }
  });
  if (remainingItems.length > 0 && remainingItems.length < afterItems.length) {
    return sortInAfterItems(result, remainingItems);
  }
  return [...result, ...remainingItems];
};
const sortNavigationItems = (navigationItems) => {
  const withoutPositionItems = navigationItems.filter((item) => !item.position);
  const afterItems = navigationItems.filter((item) => {
    var _a;
    return !!((_a = item.position) == null ? void 0 : _a.after);
  });
  const lastItems = navigationItems.filter((item) => {
    var _a;
    return !!((_a = item.position) == null ? void 0 : _a.last);
  });
  return [...sortInAfterItems(withoutPositionItems, afterItems), ...lastItems];
};
export default sortNavigationItems;
